module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_le_11_22_07_off.ed007143.svg";